module.exports = __webpack_public_path__ + "img/abr_jp.3b0812b.jpg";